import { useState, useRef, useEffect } from "react";
import { CgProfile } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { MdOutlineLogout } from "react-icons/md";
import { IoReorderThreeOutline } from "react-icons/io5";
import { useUser } from "../../context/UserContext";
import { RiNotification2Line } from "react-icons/ri";
import { format } from "date-fns";
import HrSearchBar from "./HrSearchBar";

function HrNavBar() {

  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [notifications] = useState([]);

  const notifRef = useRef();
  const profileRef = useRef();
  const { currentUser, setCurrentUser, loading } = useUser();

  const handleLogout = () => {
  localStorage.removeItem("token");  // remove JWT
  setCurrentUser(null);              // clear user state
  navigate("/login");                // redirect
};



  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setShowNotification(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (loading) {
    return (
      <div className="h-20 flex items-center justify-between px-4 sm:px-6 relative z-50">
        <div className="flex items-center gap-3">
          <motion.img
            src="/companylogo.png"
            alt="Company Logo"
            className="h-10 w-auto"
          />
        </div>
        <div className="flex items-center gap-5">
          <div className="hidden sm:block">
            <div className="h-10 w-64 bg-slate-200 rounded-full animate-pulse"></div>
          </div>
          <div className="h-10 w-10 bg-slate-200 rounded-full animate-pulse"></div>
          <div className="h-10 w-10 bg-slate-200 rounded-full animate-pulse"></div>
        </div>
      </div>
    );
  }

  // Add null check for currentUser
  if (!currentUser) {
    return null;
  }

  return (
    <div className="top-0 h-20 flex items-center justify-between px-4 sm:px-8 z-[999]">
      {/* Left: Hamburger + Logo/Favicon */}
      <div className="flex items-center gap-3">
        
        {/* Main logo for desktop */}
        <motion.img
          src="/companylogo.png"
          alt="Company Logo"
          className="h-16 w-auto "
          transition={{ duration: 0.8 }}
          whileHover={{ scale: 1.1 }}
        />
      </div>

      {/* Right: Search (desktop), Notifications, Profile */}
      <div className="flex items-center gap-5 relative">
        {/* Search - desktop only 
        <div className="hidden sm:block">
          <HrSearchBar />
        </div>
         */}
        {/* Notifications 
        <div ref={notifRef} className="relative">
          <button
            onClick={() => setShowNotification(!showNotification)}
            aria-label="Notifications"
            className="text-slate-800 hover:text-black transition-colors relative p-1 hover:scale-110 active:scale-95 duration-200"
          >
            <RiNotification2Line className="text-3xl" />
            {notifications.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                {notifications.length}
              </span>
            )}
          </button>
          {showNotification && (
            <div className="absolute right-0 mt-2 w-64 bg-white border border-slate-200 shadow-lg rounded-lg p-3 z-50 animate-slide-down origin-top">
              <h2 className="font-semibold mb-2 text-slate-800">Notifications</h2>
              {notifications.length === 0 ? (
                <span className="text-slate-400 text-sm">No notifications</span>
              ) : (
                <ul className="space-y-1 text-sm text-slate-600">
                  {notifications.map((note, i) => (
                    <li
                      key={i}
                      className="py-1 hover:bg-slate-50 px-2 rounded transition-colors duration-200"
                    >
                      {note}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
        */}
        {/* Profile dropdown */}
        <div ref={profileRef} className="relative">
          <button
            onClick={() => setShowProfile(!showProfile)}
            aria-label="Profile"
            className="text-slate-800 hover:text-black transition-colors p-1 hover:scale-110 active:scale-95 duration-200"
          >
            <CgProfile className="text-3xl" />
          </button>
          {showProfile && (
            <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 shadow-xl rounded-lg p-4 z-[100] text-sm animate-slide-down origin-top">
              
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 w-full text-bold text-left text-red-500 hover:bg-gray-100 hover:rounded-full rounded p-2
          transition-all duration-200 hover:translate-x-1 active:scale-95"
              >
                <MdOutlineLogout className="text-lg text-bold" /> Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HrNavBar;
